import React, { useMemo } from 'react';

import AnimatedDot from './AnimatedDot';
import { usePolyAnimationSync } from './hooks/usePolyAnimationSync';
import { POLY_LOADER_CONFIGS } from './PolyLoaderConfig';
import { delays as defaultDelays, groupings, pathData } from './pathData';

export interface PolyLoaderProps {
  type?: 'greyscale' | 'logo';
  /** Override delay per group: [center, middle, outer] */
  delayValues?: [number, number, number];
  /** Animation duration in seconds */
  duration?: number;
}

const PolyLoaderComponent: React.FC<PolyLoaderProps> = ({
  type: type = 'greyscale',
  delayValues,
  duration,
}) => {
  const { sync: globalSync } = usePolyAnimationSync();

  const dotDelays = useMemo(
    () => (delayValues ? groupings.map(g => delayValues[g]) : defaultDelays),
    [delayValues],
  );

  const colorConfig = POLY_LOADER_CONFIGS[type];

  return (
    <svg
      aria-label="Poly logo"
      data-test-id="loading-icon"
      role="img"
      style={{ display: 'block' }}
      viewBox="0 0 32 32"
    >
      {pathData.map((d, i) => (
        <AnimatedDot
          key={d}
          d={d}
          delay={globalSync + dotDelays[i]}
          fill={colorConfig.fill}
          fillActive={colorConfig.fillActive}
          duration={duration}
        />
      ))}
    </svg>
  );
};

export const PolyLoader = React.memo(PolyLoaderComponent);
PolyLoader.displayName = 'PolyLoader';
export default PolyLoader;
